import React from 'react';
import { Button } from '../../ui/Button';
export const PMHero = () => {
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const openCalendly = () => {
    window.open('https://calendly.com/zerototendigital/exploration-feature-design', '_blank');
  };
  return <section id="hero" className="min-h-[80vh] w-full flex flex-col justify-center relative overflow-hidden bg-purple-50" data-id="element-620">
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-purple-100 to-purple-50 rounded-full opacity-40 -mr-48 -mt-48" data-id="element-621"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-gradient-to-tl from-purple-100 to-purple-50 rounded-full opacity-30 -ml-40 -mb-40" data-id="element-622"></div>
      <div className="container mx-auto px-4 md:px-6 py-24 pt-32 relative z-10" data-id="element-623">
        <div className="max-w-4xl mx-auto" data-id="element-624">
          <p className="text-text-secondary text-lg mb-4" data-id="element-625">
            Meet a senior PM on your first call. No SDRs. Start within 48 hours.
          </p>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-black mb-6 leading-tight" data-id="element-626">
            Your Personal{' '}
            <span className="text-primary" data-id="element-627">AI Product Manager.</span>
            <br data-id="element-628" />
            Supercharged by <span className="text-primary" data-id="element-629">AI.</span>
          </h1>
          <p className="text-lg md:text-xl text-text-secondary max-w-2xl mb-10" data-id="element-630">
            Senior product leadership embedded in your team — delivering vision,
            roadmaps, and shipped outcomes from day one.
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-631">
            <Button variant="primary" onClick={openCalendly} className="text-lg" data-id="element-632">
              Speak with a Senior PM
            </Button>
            <Button variant="secondary" onClick={() => scrollTo('pricing')} className="text-lg" data-id="element-633">
              See pricing
            </Button>
          </div>
        </div>
      </div>
    </section>;
};